import * as React from 'react'

import { LineChart, colors, fonts, useClassNames } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'

import * as styles from './index.vanilla.css'

type Props = Parameters<
  NonNullable<React.ComponentProps<typeof LineChart>['renderBottomAxisTick']>
>[0] & {
  selected?: boolean
  // Nivo Line doesn't correctly type props, so we have to use any for compatibility
  onTickClick: (value: any) => void
}

export const ClickableChartBottomTick = ({
  textAnchor,
  textBaseline,
  textX,
  textY,
  value,
  x,
  y,
  selected,
  format,
  onTickClick,
}: Props) => {
  const cx = useClassNames(styles)

  const textElementRef = React.useRef<SVGTextElement>(null)
  const [backgroundRectWidth, setBackgroundRectWidth] = React.useState(40)

  const formattedValue: string = format ? format(value) : value

  // An initial attempt was made using <foreignObject>,
  // but was discarded because of a Safari SVG bug (https://bugs.webkit.org/show_bug.cgi?id=23113)
  // The code can be seen here: https://github.com/factorialco/factorial/commit/c687c9833091830a7526a63de1ce5589c5c3cad6
  useEffect(() => {
    if (textElementRef.current) {
      const textElementWidth = textElementRef.current.getComputedTextLength()

      setBackgroundRectWidth(textElementWidth + 10)
    }
  }, [formattedValue])

  return (
    <g
      transform={`translate(${x},${y})`}
      onClick={() => onTickClick(value)}
      className={styles.bottomAxisTick}
    >
      <text
        ref={textElementRef}
        transform={`translate(${textX},${textY + 10})`}
        alignmentBaseline={textBaseline as React.SVGAttributes<SVGTextElement>['alignmentBaseline']}
        textAnchor={textAnchor}
      >
        <tspan
          style={{
            fill: colors.grey800,
            fontWeight: fonts.weights.medium,
            fontFamily: 'inter',
            font: fonts.sizes['100'],
          }}
        >
          {formattedValue}
        </tspan>
      </text>
      <rect
        className={cx('background', { selected })}
        x={-backgroundRectWidth / 2}
        y="7"
        width={backgroundRectWidth}
        height="23"
        rx="7.5"
      />
    </g>
  )
}
